<!-- components/Radio.vue -->
<script setup lang="ts">
interface Option {
  label: string
  value: any
}

interface Props {
  modelValue?: any
  label?: string
  options: Option[]
  name: string
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})

const emit = defineEmits<{
  'update:modelValue': [value: any]
}>()

const updateValue = (value: any) => {
  if (!props.disabled) {
    emit('update:modelValue', value)
  }
}
</script>

<template>
    <div class="radio-group flex items-center justify-between">
        <label v-if="label" class="radio-label text-sm text-[#1A1A1A] font-medium mb-1">{{ label }}</label>
        <div class="radio-options flex gap-4">
            <label v-for="option in options" :key="option.value"
                class="radio-option flex items-center gap-2 cursor-pointer transition-all duration-200">
                <input type="radio" :name="name" :value="option.value" :checked="modelValue === option.value"
                    :disabled="disabled" @change="updateValue(option.value)"
                    class="radio-input absolute opacity-0 cursor-pointer" />
                <span
                    class="radio-custom w-[19px] h-[19px] aspect-square border-2 border-[#0000008a] rounded-full relative transition-all duration-200 flex-shrink-0"></span>
                <span class="radio-text text-sm  select-none"
                    :class="modelValue === option.value ? 'text-[#1A1A1A]' : 'text-[#6C6C6C]'">{{ option.label }}</span>
            </label>
        </div>
    </div>
</template>

<style scoped>
.radio-option:hover .radio-custom {
    border-color: #2d5396;
}

.radio-input:checked+.radio-custom {
    border-color: #FFF;
    background-color: #FFF;
    border: 2px solid #2626BF;
    display: flex;
    align-items: center;
    justify-content: center;
}

.radio-input:checked+.radio-custom::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 9.8px;
    aspect-ratio: square;
    background-color: #2626BF;
    border-radius: 50%;
}

.radio-input:disabled+.radio-custom {
    border-color: #eaeef5;
    background-color: #f5f7fa;
    cursor: not-allowed;
}

.radio-input:disabled:checked+.radio-custom {
    border-color: #a0a4ab;
    background-color: #a0a4ab;
}

.radio-input:disabled~.radio-text {
    color: #a0a4ab;
    cursor: not-allowed;
}
</style>
